"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cart_1 = __importDefault(require("../helpers/cart"));
var log_1 = __importDefault(require("../helpers/log"));
var miniBasket_1 = __importDefault(require("./miniBasket"));
var btnCheckout_1 = __importDefault(require("./btnCheckout"));
var utilities_1 = require("../helpers/utilities");
var Quantity = /** @class */ (function () {
    function Quantity() {
    }
    Quantity.prototype.init = function () {
        var _this = this;
        var quantities = document.querySelectorAll('[data-quantity]');
        quantities.forEach(function (quantity) { return _this.load(quantity); });
    };
    Quantity.prototype.load = function (quantity) {
        var _a;
        quantity.addEventListener('change', this.handleChange.bind(this, quantity));
        var plus = quantity.parentNode.querySelector('[data-quantity-plus]');
        var minus = quantity.parentNode.querySelector('[data-quantity-minus]');
        if ((_a = quantity.dataset) === null || _a === void 0 ? void 0 : _a.patternQuantity)
            this.setMaxQuantity(quantity);
        if (plus)
            plus.addEventListener('click', this.handleClickPlus.bind(this, quantity));
        if (minus)
            minus.addEventListener('click', this.handleClickMinus.bind(this, quantity));
        document.addEventListener('quantity:change', this.handleQuantityChange.bind(this, quantity));
    };
    Quantity.prototype.setMaxQuantity = function (quantity) {
        var _a, _b;
        var container = quantity.closest('[data-mini-basket-item], [data-line-item]');
        if (container && quantity.dataset.patternQuantity !== 'null') {
            var title = ((_a = container.dataset.lineItem) === null || _a === void 0 ? void 0 : _a.length) === 0 ? container.querySelector('[data-line-item-title]') : container.querySelector('.mini-basket-item__title');
            var splitChar = ((_b = container.dataset.lineItem) === null || _b === void 0 ? void 0 : _b.length) === 0 ? ':' : '-';
            var titleFormatted = title.textContent.split(splitChar)[1].trim();
            var firstProperty = container.querySelector('.mini-basket-item__property');
            var isBinding = firstProperty ? firstProperty.textContent.toLowerCase().includes('binding') : false;
            var area = (0, utilities_1.calcQuantityByArea)(titleFormatted, isBinding);
            var max = Math.floor(parseInt(quantity.dataset.patternQuantity) / area);
            quantity.max = max.toString();
        }
    };
    Quantity.prototype.handleClickPlus = function (quantity) {
        var value = parseInt(quantity.value) + 1;
        this.update(quantity, value);
    };
    Quantity.prototype.handleClickMinus = function (quantity) {
        var value = parseInt(quantity.value) - 1;
        this.update(quantity, value);
    };
    Quantity.prototype.handleChange = function (quantity) {
        var value = parseInt(quantity.value);
        this.update(quantity, value);
    };
    Quantity.prototype.handleQuantityChange = function (quantity) {
        btnCheckout_1.default.loaded();
        this.enable(quantity);
    };
    Quantity.prototype.update = function (quantity, value) {
        return __awaiter(this, void 0, void 0, function () {
            var variantId, max, price;
            return __generator(this, function (_a) {
                this.disable(quantity);
                btnCheckout_1.default.loading();
                variantId = parseInt(quantity.dataset.variantId);
                max = parseInt(quantity.max);
                price = quantity.dataset.price;
                if (value > max)
                    value = max, quantity.value = quantity.max;
                this.request({
                    key: quantity.dataset.key,
                    quantity: value,
                    variantId: variantId,
                    price: price
                });
                return [2 /*return*/];
            });
        });
    };
    Quantity.prototype.disable = function (quantity) {
        var plus = quantity.parentNode.querySelector('[data-quantity-plus]');
        var minus = quantity.parentNode.querySelector('[data-quantity-minus]');
        if (plus)
            plus.classList.add('quantity--disabled');
        if (minus)
            minus.classList.add('quantity--disabled');
    };
    Quantity.prototype.enable = function (quantity) {
        var plus = quantity.parentNode.querySelector('[data-quantity-plus]');
        var minus = quantity.parentNode.querySelector('[data-quantity-minus]');
        if (plus)
            plus.classList.remove('quantity--disabled');
        if (minus)
            minus.classList.remove('quantity--disabled');
    };
    Quantity.prototype.request = function (detail) {
        return __awaiter(this, void 0, void 0, function () {
            var updates, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updates = {};
                        updates[detail.variantId] = detail.quantity;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, cart_1.default.update({ updates: updates })];
                    case 2:
                        _a.sent();
                        miniBasket_1.default.update();
                        this.dispatchEvent(detail);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        log_1.default.error(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Quantity.prototype.dispatchEvent = function (detail) {
        document.dispatchEvent(new CustomEvent('quantity:change', { detail: detail }));
    };
    return Quantity;
}());
exports.default = new Quantity();
